import { RouterProvider } from 'react-router-dom';
import { AuthInitializer } from '@/components/AuthInitializer';
import { Providers } from '@/providers';
import { TenantBrandingEffect } from '@/layouts/components/TenantBrandingEffect';
import { router } from '@/routes';
import { PlatformApp } from './PlatformApp';
import { CustomerPortalApp } from './CustomerPortalApp';

// VITE_APP_CONTEXT is baked in at build time.
// When not set (single-image deployment), fall back to URL path so that
// /platform/* and /customer-portal/* routes are served by their own app
// branch without requiring a separate build artifact (D-050: Customer
// Portal is a route branch, not a fourth top-level app).
const APP_CONTEXT = import.meta.env.VITE_APP_CONTEXT;
const isPlatformRoute = window.location.pathname.startsWith('/platform');
const isCustomerPortalRoute = window.location.pathname.startsWith('/customer-portal');

export function App() {
  if (APP_CONTEXT === 'platform' || (APP_CONTEXT !== 'tenant' && isPlatformRoute)) {
    return <PlatformApp />;
  }

  if (APP_CONTEXT !== 'tenant' && APP_CONTEXT !== 'platform' && isCustomerPortalRoute) {
    return <CustomerPortalApp />;
  }

  return (
    <Providers>
      {/* Tenant branch only — the Platform Console keeps its own fixed
          branding. Mounted outside the router so it stays alive across
          login/logout and can reset the title and favicon when the session
          ends, rather than leaving the previous tenant's branding behind. */}
      <TenantBrandingEffect />
      <AuthInitializer>
        <RouterProvider router={router} />
      </AuthInitializer>
    </Providers>
  );
}
